import { PricingPlan } from '../../../interfaces/pricingPlan'
import { Tooltip, TooltipContent, TooltipProvider } from '../../UI/Tooltip'
import { Slider } from '../../UI/Slider'

interface PlanSliderProps {
  plans: PricingPlan['product'][]
  unit: string
  currentIndex: number
  onValueChange?: (index: number) => void
}

const PlanSlider = ({
  onValueChange,
  currentIndex,
  unit,
  plans,
}: PlanSliderProps) => {
  return (
    <div className='w-full max-w-2xl mx-auto relative mb-8 mt-20'>
      <TooltipProvider>
        <Tooltip open>
          <Slider
            value={[currentIndex]}
            min={0}
            max={plans.length - 1}
            step={1}
            onValueChange={(value: number[]) => {
              const snapped = value[0]
              onValueChange?.(snapped)
            }}
          />
          <TooltipContent
            side='top'
            align='center'
            sideOffset={5}
            className='bg-white text-black rounded-lg shadow-lg px-4 py-2'
            style={{
              filter: 'drop-shadow(0 3px 3px rgba(12, 117, 255, 0.20))',
            }}
          >
            <p className='text-center font-bold text-[15px] font-logo'>
              {plans[currentIndex]?.seats}
            </p>
            <p className='text-xs text-[#001A3B] font-logo'>{unit}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  )
}

export default PlanSlider
